import { Dungeon } from '../types';

/**
 * Exporta a masmorra atual como um arquivo JSON para download.
 * @param dungeon O objeto da masmorra a ser salvo.
 */
export const exportDungeonToJson = (dungeon: Dungeon): void => {
    if (!dungeon) return;

    const fileName = `dungeon-weaver-${dungeon.name.replace(/\s+/g, '-').toLowerCase()}-${new Date().toISOString().split('T')[0]}.json`;
    const json = JSON.stringify(dungeon, null, 2);
    const blob = new Blob([json], { type: 'application/json' });
    const href = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = href;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(href);
};

/**
 * Importa uma masmorra de um arquivo JSON.
 * Realiza validações básicas para garantir que o formato é compatível.
 * @param file O arquivo selecionado pelo usuário.
 */
export const importDungeonFromJson = (file: File): Promise<Dungeon> => {
    return new Promise((resolve, reject) => {
        if (file.type !== 'application/json') {
            reject(new Error('O arquivo deve ser um JSON válido.'));
            return;
        }

        const reader = new FileReader();

        reader.onload = (e) => {
            try {
                const content = e.target?.result as string;
                const parsed = JSON.parse(content);

                // Validação mínima de schema "duck typing"
                if (!parsed.id || !Array.isArray(parsed.rooms) || !Array.isArray(parsed.connections)) {
                    throw new Error('Estrutura de arquivo inválida. Certifique-se de que é um backup do Dungeon Weaver.');
                }

                resolve(parsed as Dungeon);
            } catch (err) {
                reject(err instanceof Error ? err : new Error('Erro desconhecido ao processar arquivo.'));
            }
        };

        reader.onerror = () => {
            reject(new Error('Falha ao ler o arquivo.'));
        };

        reader.readAsText(file);
    });
};
